<template>
  <div
    class="leo-banner leo-container leo-left-0 leo-right-0 leo-mx-auto"
    :class="
      isShow
        ? 'leo-banner--active leo-opacity-100 leo-visible leo-mt-2xl tablet:leo-mt-0'
        : 'leo-invisible leo-opacity-0 leo-absolute'
    "
    :style="{ top: `${positionTop}px` }"
  >
    <div class="leo-row">
      <div class="leo-col-4 tablet:leo-col-8 desktop:leo-col-12">
        <div
          class="leo-text-left leo-rounded-xs leo-z-8 leo-py-lg leo-px-xl leo-flex leo-items-center leo-border-sm leo-border-solid"
          :class="{
            [`leo-border-${borderColor}`]: borderColor,
            [`leo-bg-${backgroundColor}`]: backgroundColor,
          }"
        >
          <div class="leo-mb-auto leo-mr-md">
            <leo-icon
              :type="`${icon}`"
              :color="`${iconColor}`"
              size="lg"
            ></leo-icon>
          </div>
          <div
            class="leo-banner--content leo-block leo-break-word tablet:leo-break-normal"
          >
            <div class="leo-text-sm leo-text-secondary">
              {{ message }}
            </div>
          </div>
          <div
            class="leo-mb-auto leo-ml-md"
            v-if="closeButton"
            @click="handleClose"
          >
            <leo-icon
              class="leo-cursor-pointer"
              type="close"
              color="secondary"
              size="lg"
            ></leo-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { VueLeoIcon } from "@greateasternlife/leo-icon";
export default {
  name: "PermAlert",
  components: {
    "leo-icon": VueLeoIcon,
  },
  props: {
    message: {
      type: String,
      default: "",
    },
    isShow: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      closeButton: false,
      backgroundColor: "light-success", //lighter-red
      iconColor: "success", //primary
      icon: "action-completed",
      borderColor: "success",
      positionTop: 32,
      timeout: 20000,
    };
  },
  mounted() {
    this.backgroundColor = "lighter-red";
    this.iconColor = "primary";
    this.icon = "alert";
    this.borderColor = "darker-red";
  },
};
</script>
<style scoped>
.leo-banner--content {
  width: calc(100% - 20px);
}
.leo-break-word {
  word-break: break-word;
}
</style>
